import React, { useState, useEffect, useRef } from 'react';
import AwardsStrip from './AwardsStrip';

const PHONE = '0466955793';
const PHONE_D = '0466 955 793';

const SUBURBS = [
  ['Albany Creek', 'albany-creek'], ['Bray Park', 'bray-park'], ['Brendale', 'brendale'],
  ['Cashmere', 'cashmere'], ['Eatons Hill', 'eatons-hill'], ['Kallangur', 'kallangur'],
  ['Murrumba Downs', 'murrumba-downs'], ['North Lakes', 'north-lakes'], ['Petrie', 'petrie'],
  ['Strathpine', 'strathpine'], ['Warner', 'warner'],
];

const SERVICES = [
  ['All services', '/#services'],
  ['Regular house cleaning', '/house-cleaning'],
  ['Deep & reset clean', '/deep-cleaning'],
  ['Bond / exit clean', '/bond-cleaning'],
  ['NDIS home cleaning', '/ndis-cleaning'],
  ["DVA / Veterans' home cleaning", '/veterans-cleaning'],
  ['Real estate turnovers', '/partners'],
  ['Commercial cleaning', '/book'],
  ['__divider__', ''],
  ['Products we use', '/clean-like-a-pro'],
];

const ABOUT = [
  ['Our promise', '/#standard'],
  ['Our awards', '/awards'],
  ['Reviews', '/#reviews'],
  ['FAQ', '/#faq'],
  ['Pricing', '/#pricing'],
  ['__divider__', ''],
  ['For agencies', '/partners'],
  ['Careers — we\u2019re hiring', '/careers'],
  ['Login', '/login'],
];

const Caret = () => (
  <svg className="nv-caret" width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
);

function activeMenu(path) {
  if (/^\/house-cleaning-/.test(path)) return 'areas';
  if (['/house-cleaning', '/deep-cleaning', '/bond-cleaning', '/ndis-cleaning', '/veterans-cleaning', '/clean-like-a-pro'].includes(path) || /^\/(bond|deep)-cleaning-/.test(path)) return 'services';
  if (['/partners', '/login', '/careers'].includes(path)) return 'about';
  return '';
}

export default function SiteNav({ announce = 'Premium home cleaning across the Moreton Bay area — now taking new clients' }) {
  const [open, setOpen] = useState(''); // desktop dropdown key
  const [menuOpen, setMenuOpen] = useState(false); // mobile drawer
  const [acc, setAcc] = useState(''); // mobile accordion group
  const ref = useRef(null);
  const active = typeof window !== 'undefined' ? activeMenu(window.location.pathname) : '';

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(''); };
    const onEsc = (e) => { if (e.key === 'Escape') { setOpen(''); setMenuOpen(false); } };
    document.addEventListener('click', onDoc);
    document.addEventListener('keydown', onEsc);
    return () => { document.removeEventListener('click', onDoc); document.removeEventListener('keydown', onEsc); };
  }, []);

  useEffect(() => { document.body.style.overflow = menuOpen ? 'hidden' : ''; }, [menuOpen]);

  const renderMenuLink = ([label, href]) =>
    label === '__divider__' ? <div className="nv-div" key="d" /> : <a href={href} key={href + label}>{label}</a>;

  return (
    <>
      <AwardsStrip />
      <div className="announce"><div className="wrap"><span className="l">{announce}</span><a href={`tel:${PHONE}`}><svg className="ic" viewBox="0 0 24 24"><use href="#i-phone" /></svg> {PHONE_D}</a></div></div>

      <header className="nav" id="nav"><div className="wrap" ref={ref}>
        <a href="/" className="logoimg" aria-label="The T Touch home" style={{ width: 140, height: 58 }}></a>

        <nav className="nv-links" aria-label="Primary">
          <div className={`nv-item${open === 'services' ? ' open' : ''}`}>
            <button className={`nv-top${active === 'services' ? ' active' : ''}`} aria-haspopup="true" aria-expanded={open === 'services'} aria-controls="nv-services" onClick={() => setOpen(open === 'services' ? '' : 'services')} data-testid="nav-services">Services <Caret /></button>
            <div className="nv-menu" id="nv-services" role="menu">
              {SERVICES.map(renderMenuLink)}
            </div>
          </div>

          <div className={`nv-item${open === 'areas' ? ' open' : ''}`}>
            <button className={`nv-top${active === 'areas' ? ' active' : ''}`} aria-haspopup="true" aria-expanded={open === 'areas'} aria-controls="nv-areas" onClick={() => setOpen(open === 'areas' ? '' : 'areas')} data-testid="nav-areas">Areas <Caret /></button>
            <div className="nv-menu areas" id="nv-areas" role="menu">
              <a className="all" href="/house-cleaning"><span className="sp">✦</span>All Moreton Bay suburbs</a>
              <div className="nv-div" />
              <div className="nv-grid">
                {SUBURBS.map(([name, slug]) => <a href={`/house-cleaning-${slug}`} key={slug}>{name}</a>)}
              </div>
            </div>
          </div>

          <div className={`nv-item${open === 'about' ? ' open' : ''}`}>
            <button className={`nv-top${active === 'about' ? ' active' : ''}`} aria-haspopup="true" aria-expanded={open === 'about'} aria-controls="nv-about" onClick={() => setOpen(open === 'about' ? '' : 'about')} data-testid="nav-about">About <Caret /></button>
            <div className="nv-menu" id="nv-about" role="menu">
              {ABOUT.map(renderMenuLink)}
            </div>
          </div>
        </nav>

        <div className="nav-r">
          <a href="/book" className="btn btn-solid nv-book" data-testid="nav-book"><span className="cta-full">Book / Get a quote</span><span className="cta-mini">Book</span></a>
          <a href={`tel:${PHONE}`} className="nav-phone nv-phone"><svg className="ic" viewBox="0 0 24 24" style={{ width: 16, height: 16 }}><use href="#i-phone" /></svg><span className="ph-num">{PHONE_D}</span></a>
          <button className="burger" id="burger" aria-label="Open menu" aria-controls="drawer" aria-expanded={menuOpen} onClick={() => setMenuOpen(true)} data-testid="nav-burger"><span></span><span></span><span></span></button>
        </div>
      </div></header>

      <div className={`drawer${menuOpen ? ' open' : ''}`} id="drawer" role="dialog" aria-modal="true" aria-label="Menu" onClick={(e) => { if (e.target.classList.contains('drawer')) setMenuOpen(false); }}>
        <div className="top"><a href="/" className="logoimg" aria-label="The T Touch home" style={{ width: 120, height: 50 }}></a><button className="dx" aria-label="Close menu" onClick={() => setMenuOpen(false)} data-testid="drawer-close">&times;</button></div>
        <div className="nv-drawer-cta">
          <a href="/book" className="btn btn-solid btn-lg" onClick={() => setMenuOpen(false)} data-testid="drawer-book">Book / Get a quote</a>
          <a href={`tel:${PHONE}`} className="btn btn-out btn-lg" onClick={() => setMenuOpen(false)}><svg className="ic" viewBox="0 0 24 24" style={{ width: 16, height: 16 }}><use href="#i-phone" /></svg> {PHONE_D}</a>
        </div>
        {[['Services', SERVICES], ['Areas', [['All Moreton Bay suburbs', '/house-cleaning'], ...SUBURBS.map(([n, s]) => [n, `/house-cleaning-${s}`])]], ['About', ABOUT]].map(([title, items]) => (
          <div key={title}>
            <button className="nv-acc" aria-expanded={acc === title} onClick={() => setAcc(acc === title ? '' : title)} data-testid={`acc-${title.toLowerCase()}`}>{title}<span className="pm">+</span></button>
            <div className={`nv-acc-body${acc === title ? ' open' : ''}`}>
              {items.map(([label, href]) => label === '__divider__' ? <div className="nv-div" key="d" /> : <a href={href} key={href + label} onClick={() => setMenuOpen(false)}>{label}</a>)}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
